// YouTube URL parsing utility
export const extractYouTubeId = (url: string): string | null => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

export const parseYouTubeLinks = (text: string): { cleanText: string; videoId: string | null } => {
  if (!text) return { cleanText: '', videoId: null };

  const youtubeRegex = /(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/g;
  const matches = text.match(youtubeRegex);

  if (matches && matches.length > 0) {
    const firstVideoId = extractYouTubeId(matches[0]);
    const cleanText = text.replace(youtubeRegex, '').trim();
    return { cleanText, videoId: firstVideoId };
  }

  return { cleanText: text, videoId: null };
};

export interface MediaItem {
  type: 'video' | 'image';
  videoId?: string;
  image?: { image_url: string };
  id: string;
}

// Create combined media array with video first, then images (Facebook-style)
export const createMediaItems = (videoId: string | null, images: any[]): MediaItem[] => {
  const items: MediaItem[] = [];
  
  if (videoId) {
    items.push({ type: 'video', videoId, id: 'video-0' });
  }
  
  if (images && images.length > 0) {
    images.forEach((image, index) => {
      items.push({ type: 'image', image, id: `image-${index}` });
    });
  }
  
  return items;
};